<template>
	<div>
		<span v-if="mostRecent">
			{{mostRecent.created.toDate() | moment('HH:mm D/MM/YYYY') }}
		</span>
	</div>
</template>
<script>
    
	import Vuex from "vuex"
	export default{
		name: "SurveyResponseLastUpdated", 
		props: {
			survey: {type: Object}
		}, 
		computed: {
			...Vuex.mapState( {
				surveyResponses(state){
					return state.admin.surveyResponses
				}
			}),
			mostRecent() {
				var surveyResponses = this.surveyResponses;
				var id = this.survey.id;
				var responses = [...surveyResponses].filter(a => a.survey == id ).sort((a, b) => (a.created < b.created) ? 1 : -1);
				return responses[0];
			}
		},
	/*	watch: {
			survey: {
				immediate: true, 
				handler(){
					if( !this.surveyResponses.length ){
						this.$store.dispatch("fetchSurveyResponses", this.survey.id )
					}
				}				
			}
		}*/
	}
</script>